import { Document } from '@contentful/rich-text-types';
import { PictogramsList } from './helpers/iconMapper';

export type SeoLinkPictograms = keyof typeof PictogramsList;

export interface SeoLink {
    title: string;
    subtitle?: string;
    pictogram: SeoLinkPictograms;
    links: Document;
}

export interface SeoLinkProps {
    title: string;
    seoLinks: SeoLink[];
    seeMoreLinkText?: string;
    seeMoreLinkHref?: string;
}

/**
 * Takes in a string -- usually from GraphQL -- and checks
 * whether it's a valid pictogram as defined in that type
 */
export function isValidPictogram(string: string): string is SeoLinkPictograms {
    return string in PictogramsList;
}
